<ng-container *ngIf="listOfMeasureColumn$ | async as listOfMeasureColumn">
  <tr ui-table-measure-row *ngIf="isInsideTable && listOfMeasureColumn.length" [listOfMeasureColumn]="listOfMeasureColumn" (listOfAutoWidth)="onListOfAutoWidthChange($event)"></tr>
</ng-container>
<ng-content></ng-content>
<tr class="ant-table-placeholder" ui-table-fixed-row *ngIf="showEmpty$ | async">
  <ui-embed-empty nzComponentName="table" [uiSpecificContent]="(noResult$ | async)!"></ui-embed-empty>
</tr>
